import Segmente from "./Segmente";
import { v3, quat } from "oc-threejs/short3";
import Maths3 from "oc-threejs/Maths3";


export default class Hosenhalter extends Segmente {

    constructor(vsData) {
        super(vsData);
        this.parts = [
            {
                obj: APP.findProduct('Hosenhalter')?.objName, // '805.45.204',
                origin: v3(0, 0, 0),
                scale: v3(70, 70, 70),
                quaternion: quat(0, 1, 0, 270),
                flip: {
                    from: quat(0, 1, 0, 90),
                    to: quat(0, 1, 0, 270)
                },
                mirror: {
                    flipside: 0,
                    with: v3(-75, 75, 75)
                }
            }

        ];
    }
}
